import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faq } from '../data/site';
interface FaqListProps {
  limit?: number;
}
export function FaqList({
  limit
}: FaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const items = limit ? faq.slice(0, limit) : faq;
  return <div className="divide-y divide-surface-line border-y border-surface-line" data-id="element-26" data-mp="213mavh3xvyzs">
      {items.map((item, i) => {
      const isOpen = openIndex === i;
      return <div key={item.question} data-id="element-27" data-mp="1sbsohe1qbu2a" data-mpi={i}>
            <h3 data-id="element-28" data-mp="1sarbv552ezig">
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-29" data-mp="1sb0zwn6juwli">
                <span className="text-[17px] font-semibold text-ink" data-id="element-30" data-mp="1de08ylw6n5o3">{item.question}</span>
                <ChevronDownIcon size={20} aria-hidden className={`shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-31" data-mp="19d819x2yl8tx" />
              </button>
            </h3>
            {isOpen && <p className="max-w-2xl pb-6 text-[15px] leading-relaxed text-ink-muted" data-id="element-32" data-mp="ycw0atlo7lxb">{item.reponse}</p>}
          </div>;
    })}
    </div>;
}